import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import Constants from 'components/show_drawing/Constants.jsx';

const ComboBrokenRulesBanner = ({ id, comboBrokenRules }) => {
  if (!comboBrokenRules || comboBrokenRules.length === 0) { return null; }

  // drawingId comes from the backend's recovery_*.target_drawing_id. It tells
  // ShowDrawing.jsx which OptionsCommon to target: the host (for 'same' guest
  // transformations) or the guest (for 'ask'). 'calculate' recoveries arrive
  // as null from the backend, so their buttons never render.
  //
  // Swap-options is deliberately absent. The existing swap handler reads
  // values via the top-level form's `input[name=<option>]`, which resolves to
  // the host input, not the guest's `ask_values[<relation>][<option>]`.
  // Until there's a combo-aware swap handler, the backend also drops the
  // swap CTA for guest rules (see apply_combo_recovery_targets).
  const recoveryApplyToAction = (rule, recovery) => {
    emitEvent(Constants.drawing_recovery_set_value_required, {
      id: id, rule: rule, recovery: recovery, isAddOnRule: false, drawingId: recovery.target_drawing_id
    });
  };

  const recoveryUseRecommendedValueAction = (rule) => {
    emitEvent(Constants.drawing_recovery_use_recommended_value_required, {
      id: id, rule: rule, isAddOnRule: false, drawingId: rule.recovery_recommended_value.target_drawing_id
    });
  };

  const recoveryApplyTo = (rule) => (
    <>
      <br />
      {rule.recovery_apply_to.map((recovery, index) => (
        <a key={index} href="#" onClick={(e) => { e.preventDefault(); recoveryApplyToAction(rule, recovery); }} className="btn btn-default simple-btn btn-sm" style={{ marginRight: '8px', marginTop: '4px' }}>
          <span dangerouslySetInnerHTML={{ __html: recovery.cta }} />
        </a>
      ))}
    </>
  );

  const recoverRecommendedValue = (rule) => (
    <> or <a href="#" onClick={(e) => { e.preventDefault(); recoveryUseRecommendedValueAction(rule); }} className="btn btn-default simple-btn btn-sm">
      <span dangerouslySetInnerHTML={{ __html: rule.recovery_recommended_value.cta }} />
    </a> </>
  );

  const ruleRow = (guestName, rule) => {
    const hasApplyTo = rule.recovery_apply_to && rule.recovery_apply_to.length > 0

    return (
      <div className="row" key={rule.id}>
        <div className={styles.rule_error_cont}>
          <div className="alert alert-danger fade in">
            <strong>({guestName})</strong> <i className="fa fa-exclamation-triangle"> </i> &nbsp;
            <div style={{ display: 'inline', fontWeight: 'bold' }} dangerouslySetInnerHTML={{ __html: rule.description }} />

            {hasApplyTo && recoveryApplyTo(rule)}
            {rule.recovery_recommended_value && recoverRecommendedValue(rule)}

            {hasApplyTo && <span> {t('drawing.or_try_again_with_correct_values')} </span>}
            {!hasApplyTo && <span> {t('drawing.please_try_again_with_correct_values')} </span>}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {comboBrokenRules.map((entry) => (
        <div key={entry.guest_drawing_id}>
          {entry.rules.map((rule) => ruleRow(entry.guest_name, rule))}
        </div>
      ))}
    </div>
  );
};

export default ComboBrokenRulesBanner;
